import { createTrackingUtils } from "..";
import useProfiler from "../../../hooks/useProfiler";
import useUserAgent from "../../../hooks/useUserAgent";
import useRouteName from "../../../hooks/useRouteName";

const utils = createTrackingUtils({
  name: "flights_lve_web_bf_price_strikethrough_alignment",
  stages: {
    land_on_bf: 1,
    bf_discount_available_ddot: 2,
    solo: 3,
    non_solo: 4
  },
  defaultStage: 1,
  goals: {}
});

export const useBfPriceStrikethroughVariant = () => {
  const { isLoggedIn } = useProfiler();
  const { isMobile } = useUserAgent();
  const routeName = useRouteName();
  return isLoggedIn() && routeName.includes("fare") && !isMobile && utils.trackWithDefaultStage() > 0;
};

export default { useBfPriceStrikethroughVariant, ...utils };
